import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { PastVisitPlaceEntity } from 'src/entities/PastVisitPlace.entity';

export const PAST_VISITS_QUERY_KEY = 'usePastVisitsQueryV5';

const requestPath = (startOn: string) => `/api/v5/plannings/past_order_operations/${startOn}/past_visits`;

/**
 * 過去 3 ヶ月の訪問済み地点を取得する。
 *
 * レスポンスは当日の配車内容に依存しない（API は当日を含まない期間だけを見る）ため、
 * shiftTruckIds に「その日の全 shift_truck」を渡している限り配車の保存では変化しない。
 * したがって保存後の invalidate は不要で、日付が変わるまで 1 回取得すれば足りる。
 */
export const usePastVisitsQueryV5 = (startOn: string, shiftTruckIds: number[]) => {
  // queryKey / body / enabled の全箇所で同一の sortedIds を使い、キャッシュキーと
  // リクエスト内容を決定論的に揃える。
  const sortedIds = [...shiftTruckIds].sort((a, b) => a - b);
  return useQuery({
    queryKey: [PAST_VISITS_QUERY_KEY, { startOn, shiftTruckIds: sortedIds }],

    queryFn: async () => {
      const { data } = await axios.post<PastVisitPlaceEntity[]>(
        requestPath(startOn),
        { shift_truck_ids: sortedIds },
      );
      return data;
    },

    enabled: !!startOn && sortedIds.length > 0,
    staleTime: Infinity
  });
};
